import React, { useEffect, useContext, createContext } from 'react';
import { getOffers } from 'utils/network/http';
import { useAuth } from 'hooks/useAuth/useAuth';
import config from 'utils/constants/config';

import usePolling from 'hooks/usePolling/usePolling';
import useFetchData from 'hooks/useFetchData/useFetchData';

const offersContext = createContext();

export const ProvideOffers = ({ pollingActivated, children }) => {
  const offers = useProvideOffers(pollingActivated);
  return (
    <offersContext.Provider value={offers}>{children}</offersContext.Provider>
  );
};

export const useOffers = () => {
  return useContext(offersContext);
};

// Provider hook that creates auth object and handles state
const useProvideOffers = pollingActivated => {
  const { profile } = useAuth();
  const { loading, error, data, fetchData, silentFetchData } = useFetchData({
    fetchFunc: getOffers
  });

  const { startPolling, cancelPolling, isPolling } = usePolling({
    fetchFunc: silentFetchData,
    delay: config.FAST_POLLING_DELAY
  });

  useEffect(() => {
    if (!data && profile && !error && !loading) {
      fetchData();
      if (pollingActivated) {
        startPolling();
      }
    }
    if (isPolling && !pollingActivated) {
      cancelPolling();
    }
  }, [
    data,
    fetchData,
    profile,
    error,
    loading,
    startPolling,
    cancelPolling,
    isPolling,
    pollingActivated
  ]);

  return {
    offers: (data && data.results) || [],
    loading,
    error,
    silentFetchOffers: silentFetchData,
    startPollingOffers: startPolling,
    cancelPollingOffers: cancelPolling
  };
};
